<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Service Requests</h1>
        <div class="pull-right">
          <button class="pointer btn btn-lg btn-primary" v-on:click="form.showEdit({})">Create New</button>
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Call Date</th>
                <th>Contract</th>
                <th>Request Id</th>
                <th>Name</th>
                <th>Assigned to<br> inspector</th>
                <th>Address</th>
                <th>Work Status</th>
                <th>Inspector</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>

            <tr v-for="item in form.list">
              <td>{{ item.attributes.serviceDate | date }}</td>
              <td>{{ contractName(item.attributes.contractId) }}</td>
              <td>{{ item.attributes.inspectionId }}</td>
              <td>{{ item.attributes.name }}</td>
              <td><i class="fa" :class="{ 'fa-check-square-o': item.attributes.assignedToInspector, 'fa-square-o': !item.attributes.assignedToInspector}"></i></td>
              <td class="pointer" v-on:click="showMap(`${item.attributes.address}, ${item.attributes.city} ${stateName(item.attributes.stateId)} ${item.attributes.zip} `)">
                <i class="fa fa-map"></i>
                {{ item.attributes.address }}<br>
                {{ item.attributes.city }}, {{ stateName(item.attributes.stateId) }} {{ item.attributes.zip }}
              </td>
              <td>{{ item.attributes.status }}</td>
              <td>{{ applicatorName(item.attributes.applicatorId) }}</td>

              <td>
                <router-link :to="{ name: 'data-service-request-details', params: { id: item.id }}" class="mr-10">Add Data</router-link>
                <br>
                <a class="pointer text-danger" v-on:click="form.destroy(item.id)">Delete</a>
              </td>
            </tr>


            </tbody>
            <pager :form="form"></pager>

          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
    <google-map ref="gmap"></google-map>

  </div>
</template>

<script>
  import ServiceRequestsService from '@/services/ServiceRequestsService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/service_request';
  import pager from '@/components/forms/pager';
  import googleMap from '@/components/googleMap';
  import loading from '@/components/loading';
  import searchFields from '@/components/search_fields';

  import store from '@/store';

  export default {
    name: 'service_requests',

    components: {
      pager,
      siteForm,
      googleMap,
      loading,
      searchFields
    },

    data() {
      return {
        searchFieldsList: {'name': 'Name', 'date': 'Call Date', 'address': 'Address', 'zone': 'Zone'},
        form: new Form(
          ServiceRequestsService,
          {
            applicatorId: null,
            status: 'Outstanding'
          })
      }
    },

    methods: {
      contractName(id) {
        return this.$store.getters.contractNameById(id);
      },
      municipalityName(id) {
        return this.$store.getters.municipalityNameById(id);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      },
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
      applicatorName(id) {
        return this.$store.getters.applicatorNameById(id);
      },
      larvaCountName(id) {
        return this.$store.getters.larvaCountNameById(id);
      },
      showMap(coordinates) {
        this.$refs.gmap.showMap(coordinates);
      }
    },

    mounted() {
      loader.lookups()
        .then(() => {
          this.form.getList();
        });
    }

  }
</script>

<style lang="scss">

</style>